import React, { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { Draggable } from "gsap/Draggable";
import { MdCallEnd } from "react-icons/md";
import { ImPhone } from "react-icons/im";
import { useMeeting } from "../../hooks/useMeeting";
import { useMediasoupClient } from "../../hooks/useMediasoupClient";
import { leaveMeeting } from "../../services/mediasoup-client";
import { AuthContext } from "../../contexts/AuthContext";

gsap.registerPlugin(Draggable);

export default function MeetingMiniBar() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { participants, endMeetingSession } = useMeeting();
  const {
    sendTransport, recvTransport, producerVideo, producerAudio,
    localStream, screenStream, setSendTransport, setRecvTransport,
    setProducerAudio, setProducerVideo, setIsScreenSharing, setScreenStream,
  } = useMediasoupClient();
  const barRef = useRef(null);

  useEffect(() => {
    if (!barRef.current) return;
    gsap.fromTo(barRef.current,
      { y: 80, opacity: 0, scale: 0.8 },
      { y: 0, opacity: 1, scale: 1, duration: 0.5, ease: "back.out(1.7)" }
    );
    const drag = Draggable.create(barRef.current, {
      type: "x,y",
      inertia: true,
    });
    return () => {
      drag.forEach((d) => d.kill());
    };
  }, []);

  const handleRestore = () => {
    navigate("/reunion-start");
  };

  const handleLeave = (e) => {
    e.stopPropagation();
    leaveMeeting({
      userId: user.userId,
      location: navigate,
      endMeetingSession,
      setSendTransport, setRecvTransport,
      setProducerAudio, setProducerVideo,
      setIsScreenSharing, setScreenStream,
      sendTransport, recvTransport,
      producerVideo, producerAudio,
      localStream, screenStream,
    });
  };

  return (
    <div
      ref={barRef}
      style={{
        position: "fixed",
        bottom: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "6px 8px",
        borderRadius: "50px",
        background: "#023377",
        boxShadow: "0 6px 24px rgba(2,51,119,0.35)",
        cursor: "grab",
        userSelect: "none",
      }}
    >
      <button
        onClick={handleRestore}
        title="Reprendre la réunion"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "10px 20px",
          borderRadius: "50px",
          border: "2px solid rgba(255,255,255,0.2)",
          background: "rgba(255,255,255,0.1)",
          color: "#fff",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: 600,
          transition: "background 0.2s, border-color 0.2s, transform 0.15s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "rgba(255,255,255,0.2)";
          e.currentTarget.style.borderColor = "rgba(255,255,255,0.4)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "rgba(255,255,255,0.1)";
          e.currentTarget.style.borderColor = "rgba(255,255,255,0.2)";
        }}
      >
        <ImPhone style={{ fontSize: "16px" }} />
        <span>{participants.length}</span>
        <span style={{ fontWeight: 400, opacity: 0.85 }}>Reprendre</span>
      </button>

      <button
        onClick={handleLeave}
        title="Quitter la réunion"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "42px",
          height: "42px",
          borderRadius: "50%",
          border: "none",
          background: "#ff4343",
          color: "#fff",
          cursor: "pointer",
          fontSize: "20px",
          transition: "transform 0.15s, background 0.2s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.12)";
          e.currentTarget.style.background = "#e03030";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.background = "#ff4343";
        }}
      >
        <MdCallEnd />
      </button>
    </div>
  );
}
